import {
  IBasePriceAdjustmentItemResponseConvert,
  IBasePriceItemResponseConvert,
} from "helpers/types/pricing";

export const defaultQueryProducerList = {
  address: "",
  buyer: "",
  email: "",
  fasMember: "",
  flockNo: "",
  herdNo: "",
  holdingNo: "",
  mobile: "",
  postCode: "",
  producerId: "",
  producerName: "",
  telephone: "",
  excludeProdType: "",
  pageIndex: 1,
  pageSize: 10,
};

export const defaultNewBookingForm: any = {
  buyer: "",
  cost: 0,
  dil: false,
  doa: false,
  haulierId: "",
  lairagePenId: 0,
  matrixId: undefined,
  notes: "",
  producerId: "",
  transport: "",
  categories: [],
  angusQty: 0,
  quantity: 0,
};

export const newBasePriceItem: IBasePriceItemResponseConvert = {
  key: "",
  abb: "",
  name: "",
  matrices: [],
  matricesName: "",
  categories: [],
  categoriesName: "",
  specs: [],
  specsName: "",
  breeds: [],
  breedsName: "",
  breedTypes: [],
  breedTypesName: "",
  countries: [],
  countriesName: "",
  origins: [],
  originsName: "",
  ageFrom: null,
  ageTo: null,
  ageRangeText: "",
  weightFrom: null,
  weightTo: null,
  weightRangeText: "",
  minValue: null,
  maxValue: null,
  valueRangeText: "",
  priority: 1,
  value: undefined,
  buyers: [],
  buyersName: "",
  buyersList: [],
  prodTypes: [],
  prodTypesName: "",
  producers: [],
  producersName: "",
  producersList: [],
  fqas: null,
  organic: null,
  timeOnLastHolding: 0,
  maxNumberOfMovements: 0,
  species: "",
  date: "",
  isNew: true,
};

export const newBasePriceAdjustment: IBasePriceAdjustmentItemResponseConvert = {
  key: "",
  name: "",
  abbs: [],
  abbsName: "",
  matrices: [],
  matricesName: "",
  categories: [],
  categoriesName: "",
  specs: [],
  specsName: "",
  breeds: [],
  breedsName: "",
  breedTypes: [],
  breedTypesName: "",
  countries: [],
  countriesName: "",
  origins: [],
  originsName: "",
  ageFrom: null,
  ageTo: null,
  ageRangeText: "",
  weightFrom: null,
  weightTo: null,
  weightRangeText: "",
  minValue: null,
  maxValue: null,
  valueRangeText: "",
  value: null,
  buyers: [],
  buyersName: "",
  buyersList: [],
  prodTypes: [],
  prodTypesName: "",
  producers: [],
  producersName: "",
  producersList: [],
  fqas: null,
  organic: null,
  timeOnLastHolding: 0,
  maxNumberOfMovements: 0,
  species: "",
  isNew: true,
};
